
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { defaultTurno, TurnoProps } from '../../interfaces/turnos/TurnoInterface';

export interface stateProps {
    turno:             TurnoProps;
    loadingTurno:      boolean;
}

const initialState : stateProps = {
    loadingTurno: true,
    turno: defaultTurno,
};

export const turnoSlice = createSlice({
    name: 'turno',
    initialState: initialState,
    reducers: {
        setReducerTurno: ( state, { payload } : PayloadAction<stateProps> ) => {
            state.loadingTurno = payload.loadingTurno;
            state.turno = payload.turno;
        },
    },
})

export const { setReducerTurno } = turnoSlice.actions

export default turnoSlice.reducer